import { render } from "./BFilterModal.vue?vue&type=template&id=1a55abde&ts=true"
import script from "./BFilterModal.vue?vue&type=script&lang=ts"
export * from "./BFilterModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../ss/MS/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__